export function dateCompare (inputDate, compareDate, validationType) {
  if (validationType === 'fromDateIsValid') {
    return inputDate < compareDate;
  }
  if (validationType === 'toDateIsValid') {
    return inputDate > compareDate;
  }
}
